module.exports = __webpack_public_path__ + "img/childcare.c7e45f15.png";